module.exports = __webpack_public_path__ + "img/pay_qr_outer_bg.1b3cb81a.png";